module.exports = __webpack_public_path__ + "static/media/lodestar-bg.3860ecaa.png";